export const AGENT_SEPARATE_LINE = new RegExp(/#+ DO NOT EDIT BELOW THIS LINE #+/gm)
